
export const projectsData = [
    // {
    //     projectName: 'CRYPTO_CHECKER',
    //     projectDescription:
    //         'Do you want to invest in crypto? Now you can !! Check how the crytocurrencies are going...',
    //     imageUrl: 'https://i.postimg.cc/jShgGqKd/crypto.png',

    //     projectUrl: '',
    // },
    {
        projectName: 'ECOMMERCE',
        projectDescription:
            'A full stack WEB Application built to make thingsm easy.',
        imageUrl: 'https://i.ibb.co/4MWjTMn/ecommerce.png',

        projectUrl: 'https://successful-moth-pleat.cyclic.app/',
    },
    {
        projectName: 'Real-time whiteboard',
        projectDescription:
            'Lets checkout my project on white board which works in real time',
        imageUrl: 'https://i.ibb.co/0Fw6Y55/Screenshot-560.png',

        projectUrl: 'https://myrealtimeboard.vercel.app/',
    },
    {
        projectName: 'MEDIA-HUB',
        projectDescription:
            'Get started with a new resume',
        imageUrl: 'https://i.ibb.co/PGDmWYB/Screenshot-866.png',

        projectUrl: 'https://cosmic-belekoy-6a1cce-pritam.netlify.app/',
    },
    {
        projectName: 'AI-CHATBOT',
        projectDescription:
            'A React Native AI Chatbot',
        imageUrl: 'https://i.ibb.co/XYmqzGV/Screenshot-867-24-1.png',

        projectUrl: 'https://expo.dev/@prit_21/ai-chatbot',
    },
    {
        projectName: ' User Management System ',
        projectDescription:
            'Implemented to have a look on user create , read  ,delete and update operations using java spring boot',
        imageUrl: 'https://i.ibb.co/wYPqSwW/Screenshot-868.png',

        projectUrl: 'https://github.com/Pritamsinghsolanki/CRUD',
    },
    {
        projectName: 'RESUME-MAKER',
        projectDescription:
            'Get started with a new resume',
        imageUrl: 'https://i.ibb.co/XDXt1XX/Screenshot-562.png',

        projectUrl: '',
    },
    {
        projectName: 'Short-video-app',
        projectDescription:
            'Bored with long videos try short video app',
        imageUrl: 'https://i.ibb.co/w6Wj7Ty/Screenshot-561.png',

        projectUrl: '',
    },
    {
        projectName: 'Portfolio Website',
        projectDescription:
            'As a developer/designer, you should definitely have your own portfolio website. There are endless benefits. But, a lot of people feel that it would be tough to make one.',
        imageUrl: 'https://i.ibb.co/fqb1sQm/Screenshot-563-2.png',

        projectUrl: '',
    },



    //     {
    //     projectName: '',
    //     projectDescription:
    //         'As a developer/designer, you should definitely have your own portfolio website. There are endless benefits. But, a lot of people feel that it would be tough to make one. So here I bring you a tutorial to make your own website.',
    //     imageUrl: 'https://madhavbahl.tech/portfolio-assets/proj5.PNG',

    //     projectUrl: '',
    // },

];
